import axios from 'axios'
import { SAAS_TOKEN, SAAS_USER_INFO } from './keys'
import { getCookie } from 'cookieUtils'
import qs from 'qs'

let userInfo = localStorage.getItem(SAAS_USER_INFO)
if (userInfo) {
    userInfo = JSON.parse(userInfo)
}

const isDev = process.env.NODE_ENV === 'development'

axios.defaults.baseURL = '//'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
axios.interceptors.request.use(function (config) {
    let token = getCookie(SAAS_TOKEN)
    // 非登录接口
    if (config.url.indexOf('/login') === -1 && token == undefined) {
        localStorage.clear()
        location.href = '/#/login'
        location.reload()
    }
    // 非登录接口携带token
    if (config.url.indexOf('/login') === -1) {
        config.headers.common['Authentication'] = `Basic ${token}`
    }
    return Promise.resolve(config)
}, function (error) {
    return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
    // 登录失效
    console.log(response)
    if (
        response.data.status == 553649409 ||
        response.data.status == 553650183 ||
        response.data.status == 553649952 ||
        response.data.status == 553649434
    ) {
        localStorage.clear()
        location.href = '/#/login'
        location.reload()
        return
    }

    return Promise.resolve(response.data)
}, function (error) {
    return Promise.reject(error)
})
export default class ZEUSAxios {
    constructor (options = {}) {
        this.options = options
    }

    request (options) {
        return axios.request(options)
    }

    get (url, options = {}) {
        return this.request({
            // 后端接口已迁移https，开发环境强制同步
            url: isDev ? `https:${url}` : url,
            params: {
                ...options
            }
        })
    }

    get1 (url, options = {}) {
        return this.request({
            url: isDev ? `https:${url}` : url,
            // responseType: 'arraybuffer',
            params: {
                ...options
            }
        })
    }

    delete (url, options = {}) {
        return this.request({
            method: 'delete',
            url: isDev ? `https:${url}` : url,
            params: {
                ...options
            }
        })
    }

    post (url, data, options = {}) {
        let newData = data
        if (options.headers && options.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            if (!options.upload) newData = qs.stringify(newData)
        } else {
            if (newData instanceof Object) newData = JSON.stringify(newData)
        }

        return this.request({
            method: 'post',
            url,
            data: newData,
            ...options
        })
    }

    put (url, data, options = {}) {
        if (data instanceof Object) {
            data = JSON.stringify(data)
        }
        return this.request({
            method: 'put',
            url: isDev ? `https:${url}` : url,
            data,
            ...options
        })
    }
}
const instanceAxios = new ZEUSAxios()
export const request = instanceAxios.request.bind(instanceAxios)
export const get = instanceAxios.get.bind(instanceAxios)
export const post = instanceAxios.post.bind(instanceAxios)
export const put = instanceAxios.put.bind(instanceAxios)
export const zDelete = instanceAxios.delete.bind(instanceAxios)
export const get1 = instanceAxios.get1.bind(instanceAxios)



// WEBPACK FOOTER //
// ./src/js/util/zeusAxios.js